/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Btn_Try_PlusInputs */

const en_btn_try_plus = /** @type {(inputs: Btn_Try_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free`)
};

const ar_btn_try_plus = /** @type {(inputs: Btn_Try_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مجاناً`)
};

const de_btn_try_plus = /** @type {(inputs: Btn_Try_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis`)
};

const es_btn_try_plus = /** @type {(inputs: Btn_Try_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis`)
};

const fr_btn_try_plus = /** @type {(inputs: Btn_Try_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratuit`)
};

const it_btn_try_plus = /** @type {(inputs: Btn_Try_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis`)
};

const ja_btn_try_plus = /** @type {(inputs: Btn_Try_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料`)
};

const ko_btn_try_plus = /** @type {(inputs: Btn_Try_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`무료`)
};

const pt_br_btn_try_plus = /** @type {(inputs: Btn_Try_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grátis`)
};

const ru_btn_try_plus = /** @type {(inputs: Btn_Try_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Бесплатно`)
};

const th_btn_try_plus = /** @type {(inputs: Btn_Try_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ฟรี`)
};

const tr_btn_try_plus = /** @type {(inputs: Btn_Try_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ücretsiz`)
};

const zh_cn_btn_try_plus = /** @type {(inputs: Btn_Try_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费`)
};

const zh_tw_btn_try_plus = /** @type {(inputs: Btn_Try_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免費`)
};

/**
* | output |
* | --- |
* | "Free" |
*
* @param {Btn_Try_PlusInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const btn_try_plus = /** @type {((inputs?: Btn_Try_PlusInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Btn_Try_PlusInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_btn_try_plus(inputs)
	if (locale === "ar") return ar_btn_try_plus(inputs)
	if (locale === "de") return de_btn_try_plus(inputs)
	if (locale === "es") return es_btn_try_plus(inputs)
	if (locale === "fr") return fr_btn_try_plus(inputs)
	if (locale === "it") return it_btn_try_plus(inputs)
	if (locale === "ja") return ja_btn_try_plus(inputs)
	if (locale === "ko") return ko_btn_try_plus(inputs)
	if (locale === "pt_br") return pt_br_btn_try_plus(inputs)
	if (locale === "ru") return ru_btn_try_plus(inputs)
	if (locale === "th") return th_btn_try_plus(inputs)
	if (locale === "tr") return tr_btn_try_plus(inputs)
	if (locale === "zh_cn") return zh_cn_btn_try_plus(inputs)
	return zh_tw_btn_try_plus(inputs)
});